import { render, staticRenderFns } from "./CustomerRequestCopy.vue?vue&type=template&id=a999ccc8&"
import script from "./CustomerRequestCopy.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a999ccc8')) {
      api.createRecord('a999ccc8', component.options)
    } else {
      api.reload('a999ccc8', component.options)
    }
    module.hot.accept("./CustomerRequestCopy.vue?vue&type=template&id=a999ccc8&", function () {
      api.rerender('a999ccc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/CustomerRequest/CustomerRequestComponents/CustomerRequestCopy.vue"
export default component.exports